module.exports = __webpack_public_path__ + "static/media/tyre-yellow-four4.70459a45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-yellow-four4.png
// module id = 358
// module chunks = 0